import { render, staticRenderFns } from "./KitGroup.vue?vue&type=template&id=4fcdf224&scoped=true"
import script from "./KitGroup.vue?vue&type=script&lang=js"
export * from "./KitGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcdf224",
  null
  
)

export default component.exports